import React from 'react';

const Notifhp = () => {
    return (
            <div className={'notif'}>
                <div className={'notif-date'}>10/04/24</div>
                <div className={'notif-main'}>אין להכניס אנשים לפאב עד השעה 13:00</div>
                <div className={'notif-from'}>מאת: אודי</div>
            </div>
    );
};

export default Notifhp;